// extracted by mini-css-extract-plugin
export default {"container":"MagicLinkVerification_container__C5lBm","title":"MagicLinkVerification_title__2KkwB"};